// `source` value sent to /shoutouts/create from the CTA share-link flow —
// the backend auto-follows the target team only for this source
export const SHOUTOUT_SOURCE_CTA = 'ctaShoutout';
